module.exports = __webpack_public_path__ + "static/media/abletonImg.f32762d0.png";